import * as F from 'reduker/fp-utils'
import arrayToObjectByKeyObject from 'utils/arrayToObjectByKeyObject'

export const vendorsToItemsInfo = vendors =>
  vendors.map(({ _links, ...vendorInfo }) => ({ ...vendorInfo }))

export const vendorsToObjectsItemsInfo = F.pipe(
  vendorsToItemsInfo,
  arrayToObjectByKeyObject,
)

export const formatSearchOptions = options => {
  const formattedOptions = []
  if (options) {
    for (var key in options) {
      formattedOptions.push({
        id: options[key].id,
        name: options[key].name,
        pathname: `/app/vendors/${options[key].id}`,
        back: { from: 'vendors' },
      })
    }
  }
  return formattedOptions
}
